import Vue from "vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css"; // TODO: remove this line and use scoped scss
import "./styles/app.scss";
import locale from "element-ui/lib/locale/lang/en";

import App from "./App.vue";
import VueAxios from "vue-axios";
import VueAuthenticate from "vue-authenticate";
import VueMoment from "vue-moment";
import axios from "axios";

import router from "./router";
import "./registerServiceWorker";

import { Default, Empty } from "@/layouts";
import { truncateFilter } from "./core/filters";

Vue.component("default-layout", Default);
Vue.component("empty-layout", Empty);
Vue.filter("truncate", truncateFilter);

Vue.config.productionTip = false;
Vue.prototype.$eventHub = new Vue();

Vue.use(VueAxios, axios);
Vue.use(VueAuthenticate, {
  baseUrl: process.env.VUE_APP_WEBAPI_URL,
  loginUrl: "account/login",
  tokenPrefix: "auth",
  tokenName: "token",
});
Vue.use(ElementUI, { locale });
Vue.use(VueMoment);

const vm = new Vue({
  router,
  render: h => h(App),
}).$mount("#app");
